import { createFeatureSelector } from '@ngrx/store';
import {
  FLIGHT_AVAILABILITY_TO_CHECKIN_STORE_NAME,
  FlightAvailabilityToCheckinState,
} from './flight-availability-to-checkin.state';

/** Select FlightAvailabilityToCheckin State */
export const selectFlightAvailabilityToCheckinState = createFeatureSelector<FlightAvailabilityToCheckinState>(
  FLIGHT_AVAILABILITY_TO_CHECKIN_STORE_NAME
);
